import PVSActivitiesTheme from './pvs_activities/theme';
const theme = {
    // Include theme files of each module 
    ...PVSActivitiesTheme
};
export default theme;